import { CheckCircle2 } from "lucide-react";

export default function JoinSuccess() {
    return (
        <div className="rounded-3xl border border-border bg-surface p-10 text-center md:p-14" data-testid="join-success">
            <CheckCircle2 size={52} className="mx-auto text-primary" />
            <p className="mt-6 font-display text-xl font-bold md:text-2xl">
                Thank you for submitting your Join Form, it has been sent successfully. A consultant will contact you within 1 business day.
            </p>
            <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground">
                Once we receive your contract from your recruitment company you will be sent an email with your login details to our payroll system. This will allow you to upload your Tax and Super information along with your Bank Details.
            </p>
            <p className="mt-6 text-sm text-muted-foreground">
                If you have any questions, please contact us on{" "}
                <a href="tel:1800082006" className="font-semibold text-primary">1800 082 006</a> or{" "}
                <a href="mailto:timesheets@payme.com.au" className="font-semibold text-primary">timesheets@payme.com.au</a>
            </p>
        </div>
    );
}
